module.exports = __webpack_public_path__ + "static/img/Man RTW.14a0f79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/Man RTW.jpg
// module id = zL9e
// module chunks = 1